import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SubscriptionCard = ({ subscription }) => {
  const navigate = useNavigate();

  const getPlanColor = (plan) => {
    switch (plan) {
      case 'Premium':
        return 'bg-warning/10 text-warning';
      case 'Enterprise':
        return 'bg-primary/10 text-primary';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Current Plan</h3>
          <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${getPlanColor(subscription?.plan)}`}>
            {subscription?.plan}
          </span>
        </div>
        <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Crown" size={24} color="var(--color-primary)" />
        </div>
      </div>
      <div className="space-y-3 mb-6">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Job Posts Remaining</span>
          <span className="font-semibold text-foreground">{subscription?.jobPostsRemaining} / {subscription?.jobPostsLimit}</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className="bg-primary h-2 rounded-full transition-smooth"
            style={{ width: `${(subscription?.jobPostsRemaining / subscription?.jobPostsLimit) * 100}%` }}
          />
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Featured Posts</span>
          <span className="font-semibold text-foreground">{subscription?.featuredPosts} / {subscription?.featuredPostsLimit}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Renewal Date</span>
          <span className="font-semibold text-foreground">{subscription?.renewalDate}</span>
        </div>
      </div>
      <div className="space-y-2 mb-6 p-4 bg-muted/50 rounded-lg">
        <p className="text-xs font-medium text-foreground mb-2">Premium Features</p>
        {subscription?.features?.map((feature, index) => (
          <div key={index} className="flex items-center gap-2 text-xs text-muted-foreground">
            <Icon name="Check" size={14} color="var(--color-success)" />
            <span>{feature}</span>
          </div>
        ))}
      </div>
      <Button
        variant="outline"
        fullWidth
        iconName="Zap"
        iconPosition="left"
        onClick={() => navigate('/user-profile-settings')}
      >
        Upgrade Plan
      </Button>
    </div>
  );
};

export default SubscriptionCard;